__turbopack_context__.v({
  "className": "sfprodisplayregular_68543d75-module__tgFpHW__className",
  "variable": "sfprodisplayregular_68543d75-module__tgFpHW__variable",
});
